export const sizes = {
  box: {
    maxWidth: 540,
    minWidth: 96,
    minHeight: {
      tall: 850,
      medium: 648,
      short: 248,
    },
  },
  field: {
    textField: 48,
    button: 52,
    textButton: 42,
  },
  logo: {
    box: 96,
  },
  radius: {
    sm: 8,
    md: 16,
  },
  fontSize: {
    label: 14,
    body: 16,
    bodyLarge: 18,
    titleSmall: 20,
    button: 24,
    title: 28,
    titleMedium: 32,
    h1: 34,
    h1Large: 54,
  },
} as const;
